import Component, { ComponentAttrs } from 'flarum/common/Component';
import Mithril from 'mithril';
import Tooltip from 'flarum/common/components/Tooltip';
import { PostHeaderReputationAttrs } from './types';

export default class PostHeaderReputation extends Component<PostHeaderReputationAttrs> {
  oninit(vnode: Mithril.Vnode<ComponentAttrs, this>) {
    super.oninit(vnode);
  }

  view(vnode: Mithril.Vnode<ComponentAttrs, this>): Mithril.Children {
    return (
      <div className="reputation-badge">
        <Tooltip text={this.attrs.tooltip}>
          <span class="reputation-icon">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
              <path
                fill="currentColor"
                d="M7.394 20.025q-.688-.025-1.309-.357q-.62-.331-1.172-.97q-.904-1.027-1.408-2.526Q3 14.673 3 13.058q0-1.883.701-3.535t1.926-2.877t2.867-1.935T12 4t3.506.714t2.857 1.934t1.926 2.87T21 13.04q0 1.617-.52 3.109t-1.438 2.566q-.584.661-1.196.985q-.611.324-1.296.324q-.354 0-.688-.084q-.335-.083-.67-.25l-1.4-.7q-.415-.208-.877-.312q-.463-.104-.934-.104q-.49 0-.943.104t-.85.312l-1.38.7q-.36.192-.697.275q-.338.084-.717.059m.031-1q.225 0 .463-.05t.462-.175l1.4-.7q.525-.275 1.088-.4t1.137-.125t1.15.125t1.1.4l1.425.7q.225.125.45.175t.45.05q.475 0 .91-.25q.434-.25.86-.75q.8-.95 1.24-2.275t.44-2.744q0-3.35-2.325-5.678T12 5T6.325 7.35T4 13.05q0 1.425.472 2.775T5.75 18.1q.425.5.825.713t.85.212M12 14.5q.633 0 1.066-.434q.434-.433.434-1.066q0-.22-.066-.429q-.067-.21-.18-.39L15.1 9.794q.366.344.64.784t.456.941h1.05q-.49-1.796-1.941-2.908T12 7.5T8.683 8.615t-1.948 2.904h1.03q.485-1.369 1.656-2.194T12 8.5q.637 0 1.214.18t1.1.505l-1.853 2.398q-.107-.039-.23-.061T12 11.5q-.633 0-1.066.434q-.434.433-.434 1.066t.434 1.066T12 14.5"
              />
            </svg>
          </span>
        </Tooltip>
        <span>{this.attrs.rep}</span>
      </div>
    );
  }
}
